import { createFileRoute } from '@tanstack/react-router';
import { ObjectOverview } from '@/pages/workspaces/objects/object-detail/object-overview';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/')({
  component: withRumPageRendered(ObjectOverview),
});
